// src/store/index.js
import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import app from './modules/app'
import album from './modules/stamps'
import getMsgCode from './modules/login/getCode'
import login from './modules/login/login'
import getWxUser from './modules/login/getWxUser'
import checkIsBind from './modules/login/checkIsBind'
import forgetCode from './modules/login/forgetCode'
import resetPwd from './modules/login/resetPwd'
import bindUser from './modules/login/bindUser'
import setShareInfo from './modules/share/setShareInfo'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  actions,
  modules: {
    app,
    album,
    getMsgCode,
    login,
    getWxUser,
    checkIsBind,
    forgetCode,
    resetPwd,
    bindUser,
    setShareInfo,
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js